export const ACTIONABLE_TEMPLATE_TYPES = [
  'quick_replies',
  'answer_button_feedback',
  'deflection',
  'mll',
  'list',
];

export const IN_THREAD_TEMPLATE_ACTIONS = ['list', 'answer_button_feedback'];
